<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout justify-center wrap v-if="individual">
      <v-flex xs12>
        <v-card outlined>
          <v-card-text>
            <v-layout justify-start wrap>
              <v-flex xs10 sm10 md9 lg10 xl10>
                <span
                  style="
                    color: #000000;
                    font-family: nunitosansbold;
                    font-size: 18px;
                  "
                  >Individual performance</span
                >
                <br />
                <span
                  style="
                    color: #4d4d4d;
                    font-family: nunitosansregular;
                    font-size: 13px;
                  "
                  >Based on Last Exam</span
                >
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-layout justify-start wrap>
                <v-flex
                  class="hidden-sm-and-down"
                  xs12
                  sm12
                  md12
                  lg5
                  pt-2
                  text-left
                >
                  <div id="chart">
                    <apexchart
                      type="polarArea"
                      width="350"
                      :options="chartOptions"
                      :series="series"
                    ></apexchart>
                  </div>
                </v-flex>
                <v-flex class="hidden-md-and-up" xs12 sm12 md6 lg5>
                  <div id="chart" style="padding-top: 50px">
                    <apexchart
                      type="polarArea"
                      width="250"
                      :options="chartOptions"
                      :series="series"
                    ></apexchart>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 lg7 xl7 text-left>
                  <span
                    style="
                      color: #4d4d4d;
                      font-family: nunitosansregular;
                      font-size: 12px;
                    "
                    >Select Subject for compare with each exams</span
                  >
                  <v-layout justify-center wrap pt-3 v-if="individual">
                    <v-flex xs12 sm12 md12>
                      <v-card outlined>
                        <v-card-text>
                          <v-layout justify-start wrap v-if="individual">
                            <v-flex
                              xs12
                              sm6
                              md4
                              py-2
                              style="cursor: pointer"
                              v-for="(item, i) in individual.fullData"
                              :key="i"
                              @click="sub(i, item.subject._id)"
                            >
                              <v-layout justify-center wrap>
                                <v-flex xs2 pt-2>
                                  <v-card
                                    flat
                                    tile
                                    outlined
                                    :color="item.subject.color"
                                    width="10"
                                    height="10"
                                  >
                                  </v-card>
                                </v-flex>
                                <v-flex xs10 style="cursor: pointer">
                                  <span class="subject">{{
                                    item.subject.subjectName
                                  }}</span
                                  ><br />
                                </v-flex>
                              </v-layout>
                              <span
                                style="
                                  color: #000000;
                                  font-family: nunitosansbold;
                                  font-size: 22px;
                                "
                                >{{ item.CGPA.toFixed(2) }}</span
                              ><br />
                              <span
                                style="
                                  color: #646464;
                                  font-family: nunitosanssemibold;
                                  font-size: 12px;
                                "
                                >CGPA</span
                              ><br />
                              <v-flex xs7>
                                <v-progress-linear
                                  :value="item.CGPA"
                                  :color="item.subject.color"
                                ></v-progress-linear>
                              </v-flex>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center wrap>
                            <v-flex xs12 v-if="flag">
                              <div id="chart">
                                <apexchart
                                  type="bar"
                                  height="350"
                                  :options="chartOptions3"
                                  :series="series3"
                                ></apexchart>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-layout justify-start wrap py-5 v-if="individual">
                  <v-flex
                    xs12
                    sm6
                    md2
                    pa-2
                    v-for="(item, i) in individual.fullData"
                    :key="i"
                  >
                    <v-layout justify-center wrap>
                      <v-flex xs2 pt-2>
                        <v-card
                          outlined
                          :color="selectColor(i)"
                          width="10"
                          height="10"
                        >
                        </v-card>
                      </v-flex>
                      <v-flex xs10>
                        <span class="subject">{{
                          item.subject.subjectName
                        }}</span
                        ><br />
                      </v-flex>
                    </v-layout>
                    <span
                      style="
                        color: #000000;
                        font-family: nunitosansbold;
                        font-size: 22px;
                      "
                      >{{ item.mark }}</span
                    ><br />
                    <span
                      style="
                        color: #646464;
                        font-family: nunitosanssemibold;
                        font-size: 12px;
                      "
                      >CGPI</span
                    ><br />
                    <v-flex xs7>
                      <v-progress-linear
                        :value="item.mark"
                        :color="selectColor(i)"
                      ></v-progress-linear>
                    </v-flex>
                  </v-flex>
                </v-layout> -->
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      appLoading: false,
      flag: false,
      individual: [],
      graph: [],
      series: [],
      subgraph: [],
      chartOptions: {
        chart: {
          width: 380,
          type: "polarArea",
        },
        labels: [],
        fill: {
          opacity: 1,
        },
        colors: [],
        stroke: {
          width: 1,
          colors: undefined,
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          show: false,
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanslight",
              colors: ["#4D4D4D"],
            },
          },
          data: [],
        },
        legend: {
          show: false,
          showForSingleSeries: false,
        },
        // legend: {
        //     position: "bottom",
        //   display: false,
        // },
        plotOptions: {
          polarArea: {
            rings: {
              strokeWidth: 0,
            },
            spokes: {
              strokeWidth: 0,
            },
          },
        },
        // theme: {
        //   monochrome: {
        //     enabled: true,
        //     shadeTo: "light",
        //     shadeIntensity: 0.6,
        //   },
        // },
      },
      series1: [
        {
          data: [0.5, 2.5, 5.0, 7.5, 10],
        },
      ],
      chart2: {
        chart: {
          height: 350,
          type: "bar",
        },
        // colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [
            ["1st Term"],
            ["2nd Term"],
            ["3rd Term"],
            ["4th Term"],
            ["5th Term"],
          ],
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanslight",
              colors: ["#4D4D4D"],
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanssemibold",
              colors: ["#9A9A9A"],
            },
          },
        },
      },
      series3: [
        {
          data: [],
          name: "CGPA",
        },
      ],
      chartOptions3: {
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
      },
    };
  },
  mounted() {
    this.getIndividual();
  },
  methods: {
    selectColor(index) {
      var color;
      // for (var i = 0; i < this.color.length; i++) {
      // if (index == this.color.index)
      color = this.color[index].name;
      // }
      return color;
    },
    getIndividual() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/exam/mark/studentwise",
        params: {
          student: this.storage,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.individual = response.data.data;
          if (this.individual.fullData)
            this.graph = response.data.data.fullData;
          for (var i = 0; i < this.graph.length; i++) {
            this.chartOptions.labels.push(this.graph[i].subject.subjectName);
            this.series.push(this.graph[i].CGPA.toFixed(2));
            this.chartOptions.colors.push(this.graph[i].subject.color);
            // this.series[1].data.push(this.graph[i].clientcount);
            // this.series[2].data.push(this.graph[i].productcount);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    sub(i, itemid) {
      this.flag = true;
      this.getGraph(itemid);
    },
    getGraph(itemid) {
      this.appLoading = true;
      this.flag = false;
      this.series3[0].data = [];
      this.chartOptions3.xaxis.categories = [];
      axios({
        method: "GET",
        url: "/exam/mark/studentsubjectwise",
        params: {
          student: this.storage,
          subject: itemid,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subgraph = response.data.data;
          for (var i = 0; i < this.subgraph.length; i++) {
            this.chartOptions3.xaxis.categories.push(
              this.subgraph[i].exam.ExamName
            );
            //  this.chartOptions3.xaxis.labels.push(this.subgraph[i].CGPA.toFixed(2))
            this.series3[0].data.push(this.subgraph[i].CGPA.toFixed(2));
          }
          this.flag = true;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>